import { getTheme } from '@goodlifeplus/themes'
import tailwindContainerQueryPlugin from '@tailwindcss/container-queries'
import tailwindFormsPlugin from '@tailwindcss/forms'
import tailwindTypographyPlugin from '@tailwindcss/typography'

export default (siteId) => ({
  presets: [getTheme(siteId).primitives],
  content: [
    './index.html',
    './src/**/*.{vue,js,ts,jsx,tsx}',
    './packages/glp-design-system/**/*.{vue,js,ts,jsx,tsx}',
  ],
  safelist: [
    'white',
    'pure-white',
    'pastel-blue',
    'text-primary',
    'text-primary-light',
    'text-secondary',
    'text-secondary-dark',
    'text-tertiary',
    'text-tertiary-light',
    'black',
    'purple',
  ],
  // Toggle dark-mode based on .dark class or data-mode="dark"
  darkMode: ['class', '[data-mode="dark"]'],
  theme: {
    fontFamily: {
      sans: ['Inter', 'sans-serif'],
    },
    // https://tailwindcss.com/docs/screens
    screens: {
      xs: '376px',
      // => @media (min-width: 640px) { ... }

      sm: '640px',
      // => @media (min-width: 640px) { ... }

      md: '768px',
      // => @media (min-width: 768px) { ... }

      lg: '1024px',
      // => @media (min-width: 1024px) { ... }

      xl: '1280px',
      // => @media (min-width: 1280px) { ... }

      '2xl': '1536px',
      // => @media (min-width: 1536px) { ... }
    },
    extend: {
      aspectRatio: {
        '16/9': '16 / 9',
        '9/16': '9 / 16',
        '5/4': '5 / 4',
        '4/5': '4 / 5',
      },
      spacing: {
        4.5: '1.125rem',
      },
      borderRadius: {
        100: '100px',
      },
      borderWidth: {
        10: '12px',
      },
      fontSize: {
        '2xs': '0.5rem',
        '2lg': '2rem',
      },
      // https://tailwindcss.com/docs/customizing-colors
      // https://uicolors.app/create
      // + TailwindCSS Slate
      colors: {
        'prize-tier-a': '#58FE70',
        'prize-tier-a-contrast': '#ffffff',
        'prize-tier-b': '#8C78FF',
        'prize-tier-b-contrast': '#ffffff',
        'prize-tier-c': '#38ACFF',
        'prize-tier-c-contrast': '#ffffff',
        'prize-tier-d': '#E069EC',
        'prize-tier-d-contrast': '#ffffff',
        'prize-tier-e': '#3E5F78',
        'prize-tier-e-contrast': '#ffffff',
        'prize-tier-s': '#e0aa3e',
        'prize-tier-s-contrast': '#000000',
      },
      containers: {
        xs: '376px',
        // => @media (min-width: 640px) { ... }

        sm: '640px',
        // => @media (min-width: 640px) { ... }

        md: '768px',
        // => @media (min-width: 768px) { ... }

        lg: '1025px',
        // => @media (min-width: 1024px) { ... }

        xl: '1280px',
        // => @media (min-width: 1280px) { ... }

        '2xl': '1536px',
        // => @media (min-width: 1536px) { ... }
      },
      fontFamily: {
        inter: ['Inter'],
      },
    },
  },
  plugins: [
    tailwindContainerQueryPlugin,
    tailwindFormsPlugin,
    tailwindTypographyPlugin,
    function ({ addVariant }) {
      addVariant(
        'peer-placeholder-not-shown',
        ':merge(.peer):not(:placeholder-shown) ~ &'
      ) // Adds support for `peer-placeholder-not-shown:`
    },
    function ({ matchUtilities, theme }) {
      matchUtilities(
        {
          ['min-w-screen']: (value) => {
            return { minWidth: value }
          },
        },
        {
          values: theme('screens'),
        }
      )
    },
    // Add plugin for line height calculation
    function ({ matchComponents, theme }) {
      matchComponents(
        {
          'h-line': (value) => {
            const height =
              value *
              16 *
              theme('fontSize.base[1].lineHeight').replace('rem', '')

            return { height }
          },
        },
        {
          values: {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
          },
        }
      )
    },
  ],
})
